const getCurrentRole = () => {
    const accountType = localStorage.getItem("AQATO_SuperAdminAccountType");
    return accountType || null;
};

export default getCurrentRole;